var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4491 14.5166L8.82989 19.5166C8.65487 19.6711 8.4473 19.7933 8.21909 19.8763C7.99088 19.9592 7.74651 20.0012 7.5 20C7.00407 19.9938 6.52906 19.8212 6.17011 19.5166L0.550858 14.5166C0.19815 14.2028 0 13.7772 0 13.3333C0 12.8895 0.19815 12.4638 0.550858 12.15C0.903567 11.8361 1.38194 11.6598 1.88075 11.6598C2.37955 11.6598 2.85793 11.8361 3.21064 12.15L5.62692 14.3166V1.66666C5.62692 1.22464 5.82426 0.800715 6.17553 0.488155C6.5268 0.175595 7.00323 0 7.5 0C7.99677 0 8.4732 0.175595 8.82447 0.488155C9.17574 0.800715 9.37309 1.22464 9.37309 1.66666V14.3166L11.7894 12.15C12.1421 11.8361 12.6204 11.6598 13.1193 11.6598C13.6181 11.6598 14.0964 11.8361 14.4491 12.15C14.8019 12.4638 15 12.8895 15 13.3333C15 13.7772 14.8019 14.2028 14.4491 14.5166Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/iconDownload.6d1b42b7fca892f4cd1d75bdd765ccc7.svg";
export { ForwardRef as ReactComponent };